import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.EXPENSES_DISABLED;

/**
 * Checks if the expenses workflow is disabled for the company (small ICP setup).
 *
 * @returns {boolean} True when the `expenses_disabled` company feature is enabled.
 *
 * @example
 * const isExpensesDisabled = useIsExpensesDisabled();
 */
export const useIsExpensesDisabled = () => {
  return useCompanyFeatureAvailable(featureName);
};
